const AuthTokenQueryKeys = {
  global: ["authTokens"] as const,

  /**
   * All
   */
  all: () => [...AuthTokenQueryKeys.global, "all"] as const,

  /**
   * Current
   */
  current: () => [...AuthTokenQueryKeys.global, "current"] as const,
};

export { AuthTokenQueryKeys };
